<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />
        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end "  v-if="is_admin">
        <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
        >
        <v-icon left>mdi-youtube</v-icon>
        Watch Tutorial
        </v-btn>
        </div>
        <!-- <v-card class="box" v-if="ay_std_div_list != null"> -->
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title v-if="tenant == 'sbpps'">
                    Teacher-Parent Communication
                </v-toolbar-title>
                <v-toolbar-title v-else>
                    <strong>Teacher Subject Diary</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="proceed" />
                </v-col>
            </v-row>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table dense v-if="inst_sub_taught_list!=''" :headers="headers3" :items="inst_sub_taught_list"
                    :search="search" class="mytable elevation-1">
                    <template v-slot:item.action="{ item }">
                        <div class="mt-1 mb-1">
                            <v-btn depressed small rounded outlined color="green" @click="evaluate(item)"
                                :loading="fetch_loader">Proceed</v-btn>
                        </div>
                    </template>
                    <template v-slot:[`item.comp_msg`]="{ item }">
                        <v-btn small class="button" :disabled="isvalid == false ? true : false" @click="comp_msg(item)"
                            dense>Compose Message</v-btn>
                        <p v-if="!isvalid"><b>{{Message}}</b></p>
                    </template>
                </v-data-table>
            </v-card>
        </v-card>
        <v-dialog v-model="dialog_diary" style="margin-top: 10%;" persistent fullscreen hide-overlay
            transition="dialog-top-transition">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>Course Diary List</strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn small class="button" @click="close()">Close</v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="2" md="2"></v-col>
                            <v-col cols="12" sm="4" md="4">
                                <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-bind="attrs" dense v-model="date_of_generation"
                                            @blur="date = parseDate(date_of_generation)" v-on="on"
                                            hint="From Date(Inclusive)" prepend-icon="event" outlined rounded
                                            persistent-hint></v-text-field>
                                    </template>
                                    <v-date-picker v-model="gen_date" no-title @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-bind="attrs" dense v-model="date_of_generation_to"
                                            @blur="date = parseDate(date_of_generation_to)" v-on="on"
                                            hint="To Date(Inclusive)" prepend-icon="event" outlined rounded
                                            persistent-hint></v-text-field>
                                    </template>
                                    <v-date-picker v-model="gen_date_to" no-title
                                        @input="menu2 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="mt-10">
                                <v-btn color="warning" @click="getCourseDairyData()">Fetch</v-btn>
                            </v-col>
                        </v-row>
                        <br />
                        <span v-if="course_diary_list!=''">
                            <!-- <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search"
                                :items="bookList1" :items-per-page="-1" fixed-header> -->
                                <v-data-table dense class="elevation-1 mytable" :headers="headers" :search="search" :items="bookList1"
                                    :items-per-page="-1" fixed-header show-select item-key="diary_id" v-model="selectedRows">
                                    <!-- Only show checkbox for Teacher to Parent messages -->
                                    <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                        <div class="d-flex align-center justify-center">
                                            <v-simple-checkbox v-if="item.diarymessagetype === 'Teacher to Parent'" :value="isSelected"
                                                @input="select($event)" color="primary" :ripple="false"></v-simple-checkbox>
                                    
                                            <v-icon v-else color="grey"
                                                title="Parent messages cannot be selected or deleted">mdi-alert-circle-outline</v-icon>
                                        </div>
                                    </template>
                                    <template v-slot:header.data-table-select="{ on, props }">
                                        <div class="d-flex align-center">
                                            <v-simple-checkbox v-bind="props" v-on="on" color="primary"></v-simple-checkbox>
                                
                                            <v-btn v-if="selectedRows.length > 0" icon medium color="dark red" class="ml-1" @click.stop="deleteSelected">
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>

                                <template v-slot:[`item.diarymessagetype`]="{ item }">
                                    <v-chip :color="getColor(item.diarymessagetype)">
                                        {{ item.diarymessagetype }}
                                    </v-chip>
                                </template>
                                <template v-slot:[`item.message`]="{ item }">
                                    <v-icon color="blue" @click="showDairy(item)">mdi-eye</v-icon>
                                </template>
                                <template v-slot:[`item.attachment`]="{ item }">
                                    <a v-if="item.attachment_file_name != null" target="_blank"
                                        :href="awspath + item.attachment_file_path + item.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                                    <span v-else>--</span>
                                </template>
                                <template v-slot:[`item.url`]="{ item }">
                                    <a v-if="item.url" :href="item.url" target="_blank">{{ item.url }}</a>
                                    <span v-else>--</span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <v-icon color="red" v-if="item.diarymessagetype == 'Teacher to Parent'"
                                        @click="deleteDairy(item)">mdi-trash-can</v-icon>
                                    <v-icon v-else>mdi-alert-circle-outline</v-icon>
                                </template>
                                <template v-slot:top class="pb-5">
                                    <v-row dense justify="center" align="center">
                                        <tr class="t-row">
                                            <div>
                                                <th>
                                                    <v-row>
                                                        <span v-for="header in headers" :key="header.text">
                                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details
                                                                    small rounded dense outlined color="#0F2027"
                                                                    :label="header.text" multiple clearable
                                                                    :items="columnValueList(header.value)"
                                                                    v-model="filters[header.value]"></v-autocomplete>
                                                            </span>
                                                        </span>
                                                    </v-row>
                                                </th>
                                            </div>
                                        </tr>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </span>
                        <span v-else>
                            <span>
                                <center><strong>No Data Found!!!</strong></center>
                            </span>
                        </span>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="msg_dialog" v-if="msg_data != null" max-width="1200px">
            <v-card>
                <v-toolbar flat class="toolbar">
                    <v-card-title>Message [{{ msg_data.diarymessagetype }}]</v-card-title>
                </v-toolbar>
                <v-card-text>
                    <v-card class="box">
                        <v-row justify="center">
                            <v-col sm="3" md="3"> Post date : <b>{{ msg_data.msg_post_date }}</b> </v-col>
                            <v-col sm="3" md="3"> Student : <b>{{ msg_data.learner }}</b> </v-col>
                            <v-col sm="3" md="3"> Course : <b>{{ msg_data.courseoffering }}</b> </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9">
                                Subject :
                                <v-text-field style="font-weight: bold;" outlined v-model="msg_data.subject"
                                    variant="outlined" readonly></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9">
                                Message :
                                <v-textarea style="font-weight: bold;" outlined name="input-9-6" v-model="msg_data.msg"
                                    variant="outlined" readonly></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="9" md="9" v-if="msg_data.url">
                                URL :
                                <a :href="msg_data.url" target="_blank">{{ msg_data.url }}</a>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col sm="3" md="3" v-if="msg_data.isread==true"> Read On : <b>{{ msg_data.read_date }}</b>
                            </v-col>
                            <v-col sm="3" md="3" v-if="msg_data.attachment_file_name != null">
                                Attachment : <a target="_blank"
                                    :href="awspath + msg_data.attachment_file_path + msg_data.attachment_file_name"><v-icon>mdi-attachment</v-icon></a>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card-text>
                <v-card-actions class="justify-center"><v-btn color="warning"
                        @click="msg_dialog = false">Close</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_compose_message" style="margin-top: 10%;" fullscreen hide-overlay
            transition="dialog-top-transition">
            <v-card class="mx-auto">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Compose Message</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="dialog_compose_message = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <br />
                <v-card-text v-if="course_offering_learner_list!=''">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3" v-if="course_offering_learner_list!=''">
                                <p><v-icon color="error">*</v-icon><b>Select Student</b></p>
                                <v-autocomplete color="#0F2027" dense rounded required v-model="learners"
                                    :items="course_offering_learner_list" item-text="learner" item-value="ldid"
                                    label="Student" outlined persistent-hint hint="Please Select Student" multiple />
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><v-icon color="error">*</v-icon><b>Subject</b></p>
                                <v-text-field outlined v-model="subject" label="Enter Message Subject"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><v-icon color="error">*</v-icon><b>Description</b></p>
                                <v-textarea outlined name="input-7-4" v-model="description"
                                    label="Enter Description"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><b>URL</b></p>
                                <v-text-field outlined v-model="url" label="Enter URL" placeholder="https://example.com"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="5" md="5">
                                <p><b>Attachment If Any</b></p>
                                <v-file-input rounded dense outlined prepend-icon="mdi-attachment" label="Choose File"
                                    show-size v-model="file" name="doc"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense v-if="learners && description && subject">
                            <v-btn class="mt-5 pt-0 button" @click="addDiary()" dense :loading="loader">Send</v-btn>
                        </v-row>
                    </v-card>
                </v-card-text>
                <v-card-text v-else>
                    <center><strong>0 Students register for selected subject</strong></center>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Subject Teacher Diary Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/NbFlX5O7fYk?si=zDrk5qTTEYTm0teT"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            is_admin: false,
            isvalid: true,
            Message: null,
            fetch_loader: null,
            overlay: false,
            snackbar: false,
            search: "",
            snackbar_msg: "",
            videoDialog:false,
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            inst_sub_taught_list: [],
            diary_data: [],
            course_offering_learner_list: [],
            dialog_diary: false,
            diary_message_type: null,
            course_diary_list: [],
            msg_dialog: false,
            msg_data: null,
            coff_inst_id: null,
            coff_id: null,
            dialog_compose_message: false,
            learners: [],
            selectedRows: [],
            description: "",
            file: null,
            loader: false,
            subject: "",
            url: "", // Added URL field
            menu1: false,
            menu2: false,
            date_of_generation: "",
            awspath: null,
            gen_date: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            date_of_generation_to: "",
            gen_date_to: new Date().toISOString().substr(0, 10),
            date_1: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            modal_1: false,
            date_2: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            filterArr: [],
            filters: {
                msg_post_date: [],
                learner: [],
                diarymessagetype: [],
            },
            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Post Date",
                    align: "left",
                    sortable: false,
                    value: "msg_post_date",
                },
                {
                    text: "Message Type",
                    align: "left",
                    sortable: false,
                    value: "diarymessagetype",
                },
                {
                    text: "Subject",
                    align: "left",
                    sortable: false,
                    value: "subject",
                },
                {
                    text: "Message",
                    align: "left",
                    sortable: false,
                    value: "message",
                },
                {
                    text: "Attachment",
                    align: "left",
                    sortable: false,
                    value: "attachment",
                },
                {
                    text: "URL",
                    align: "left",
                    sortable: false,
                    value: "url",
                },
                {
                    text: "Learner",
                    align: "left",
                    sortable: false,
                    value: "learner",
                },
                {
                    text: "Read On",
                    align: "left",
                    sortable: false,
                    value: "read_date",
                },
                {
                    text: "Action",
                    align: "left",
                    sortable: false,
                    value: "action",
                },
            ],
            headers3: [
                {
                    text: "Sr. No.",
                    value: "sr_no",
                    align: "center",
                },
                {
                    text: "Subject",
                    value: "course_name",
                    align: "center",
                },
                {
                    text: "Standard",
                    value: "standard",
                    align: "center",
                },
                {
                    text: "Division",
                    value: "divisionoffering",
                    align: "center",
                },
                {
                    text: "Action",
                    value: "action",
                    align: "center",
                },
                {
                    text: "Compose Message",
                    align: "left",
                    sortable: false,
                    value: "comp_msg",
                },
            ],
            tenant: null
        };
    },
    computed: {
        bookList1() {
            return this.course_diary_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
        isTeacherRole() {
    const roleType = (
        this.$route.query.role_type ||
        sessionStorage.getItem("para_role_type") ||
        ""
    ).toString().trim().toLowerCase();

    const roleName = (
        this.$route.query.role_name ||
        sessionStorage.getItem("para_role") ||
        ""
    ).toString().trim().toLowerCase();

    return roleType.includes("Class teacher") || roleName.includes("teacher");
}
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.date_of_generation = this.formatDate(this.gen_date);
        this.date_of_generation_to = this.formatDate(this.gen_date_to);
        axios
            .post("/Homework/get_homework_data")
            .then((res) => {
                this.table_data = res.data.data;
                this.ay_std_div_list = res.data.ay_data;
                this.sel_ay_data = res.data.curr_ay;
                this.isvalid = res.data.isvalid;
                this.Message = res.data.Message;

                if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }
            })
            .catch((error) => {})
            .finally(() => {});
    },
    watch: {
        gen_date(val) {
            this.date_of_generation = this.formatDate(this.gen_date);
        },
        gen_date_to(val) {
            this.date_of_generation_to = this.formatDate(this.gen_date_to);
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.course_diary_list.map((d) => d[val]);
        },
        async comp_msg(item) {
            this.coff_inst_id = [];
            this.coff_id = [];
            this.course_offering_learner_list = [];
            (this.coff_inst_id = item.course_offering_inst_id), (this.coff_id = item.course_offering_id);
            const data = {
                coff_inst_id: this.coff_inst_id,
                coff_id: this.coff_id,
            };
            try {
                const res = await axios.post("/dairy/getCourseLearners", data);
                if (res.data.flag == "YES") {
                    this.course_offering_learner_list = res.data.course_offering_learner_list;
                    this.dialog_compose_message = true;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        async evaluate(item) {
            this.coff_inst_id = [];
            this.coff_id = [];
            this.course_diary_list = [];
            (this.coff_inst_id = item.course_offering_inst_id), (this.coff_id = item.course_offering_id);
            this.dialog_diary = true;
        },
        async addDiary() {
            let formData = new FormData();
            if (this.learners.length <= 0) {
                this.showSnackbar("red", "Please select Student...");
                return;
            }
            if (this.learners.length > 1) {
                for (var i = 0; i < this.learners.length; i++) {
                    if (this.learners[i] != "") {
                        let stud = this.learners[i];
                        formData.append("learners", stud);
                    }
                }
            } else {
                formData.append("learners", this.learners);
            }
            formData.append("attachment_file", this.file);
            formData.append("description", this.description);
            formData.append("subject", this.subject);
            formData.append("url", this.url); // Added URL to form data
            formData.append("ay", this.sel_ay_data.ay_id);
            formData.append("coff_inst_id", this.coff_inst_id);
            formData.append("coff_id", this.coff_id);
            formData.append("from", "TTP");
            this.overlay = true;
            this.loader = true;
            try {
                const res = await axios.post("/dairy/addCourseDiary", formData);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Sent Successfully!");
                } else {
                    this.isvalid = res.data.isvalid;
                    this.Message = res.data.Message;
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                this.loader = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
                this.dialog_compose_message = false;
                this.learners = [];
                this.description = "";
                this.subject = "";
                this.url = ""; // Reset URL field
                this.file = null;
                this.loader = false;
            }
        },
        getColor(diarymessagetype) {
            if (diarymessagetype == "Parent to Teacher") return "#A1C2F1";
            else return "#E1AEFF";
        },
        async deleteSelected() {
            if (this.selectedRows.length === 0) return;

            if (!confirm(`Delete selected records?`)) return;

            this.overlay = true;
            try {
                const ids = this.selectedRows.map(r => r.diary_id);
                const res = await axios.post("/dairy/deleteTeacherDairy", { diary_ids: ids });
                if (res.data.flag === "YES") {
                    this.course_diary_list = this.course_diary_list.filter(
                        item => !ids.includes(item.diary_id)
                    );
                    await this.getCourseDairyData();
                    this.showSnackbar("green", "Selected diaries deleted successfully!");
                    this.selectedRows = [];
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                }
            } catch (err) {
                console.error(err);
                this.onerror(err);
            } finally {
                this.overlay = false;
            }
        },
        async deleteDairy(item) {
            const formdata = {
                diary_id: item.diary_id,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/dairy/deleteTeacherDairy", formdata);
                if (res.data.flag == "YES") {
                    await this.getCourseDairyData();
                    var index = this.course_diary_list.indexOf(item);
                    this.course_diary_list.splice(index, 1);
                    this.showSnackbar("green", "Deleted Successfully");
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                console.log("bye...");
                this.overlay = false;
            }
        },
        async showDairy(item) {
            const formdata = {
                diary_id: item.diary_id,
            };
            if (item.diarymessagetype == "Parent to Teacher" && item.isread == false) {
                this.overlay = true;
                try {
                    const res = await axios.post("/dairy/readTeacherDairy", formdata);
                    if (res.data.flag == "YES") {
                        item.read_date = res.data.read_date;
                        item.isread = true;
                        this.showSnackbar("green", res.data.snackbar);
                        this.msg_data = item;
                        this.msg_dialog = true;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            } else {
                this.msg_data = item;
                this.msg_dialog = true;
            }
        },
        proceed() {
            this.inst_sub_taught_list = [];
            const data = {
                ay: this.sel_ay_data.ay_id,
            };
            this.overlay = true;
            axios
                .post("/Dairy/getDairyCoffInst", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.inst_sub_taught_list = res.data.inst_sub_taught_list;
                        if (this.inst_sub_taught_list.length == 0) {
                            this.showSnackbar("#b71c1c", "No courses added for selected academic year!!!");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    if (this.inst_sub_taught_list == []) {
                        this.table_data = [];
                        this.showSnackbar("#b71c1c", "No records found!");
                    }
                })
                .catch((error) => {
                    this.fetch_loader = false;
                    this.overlay = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                    this.overlay = false;
                });
        },
        close() {
            this.diary_data = [];
            this.course_diary_list = [];
            this.diary_message_type = null;
            this.dialog_diary = false;
        },
        async getCourseDairyData() {
            this.diary_data = [];
            this.course_diary_list = [];
            const data = {
                date: this.date_of_generation,
                todate: this.date_of_generation_to,
                coff_id: this.coff_id,
                course_offering_inst_id: this.coff_inst_id,
            };
            axios
                .post("/Dairy/getCourseDairyData", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.diary_data = res.data.diary_data;
                        this.dialog_diary = true;
                        this.diary_data.forEach(diary => {
                            if (diary.course_diary_list && Array.isArray(diary.course_diary_list)) {
                                this.course_diary_list = [
                                    ...this.course_diary_list,
                                    ...diary.course_diary_list
                                ];
                            }
                        });
                        this.course_diary_list = this.course_diary_list.filter(entry => entry !== null && entry !== undefined);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    if (this.inst_sub_taught_list == []) {
                        this.showSnackbar("#b71c1c", "No records found!");
                    }
                })
                .catch((error) => {
                    this.fetch_loader = false;
                    this.overlay = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Unexpected error.";
            }
            this.showSnackbar("error", msg);
        },
    },
};
</script>

<style scoped></style>